module.exports = __webpack_public_path__ + "src/assets/img/german-selector-binokolus.87ce62a8.png";